<template>
  <v-app-bar app :elevation="navigation.elevation"
    :color="navigation.color"
    :dark="navigation.dark" clipped-left>
    <router-link class="d-flex align-center brand" :to="homeNav.to">
      <img :alt="appTitle" class="mr-2" width="25" height="25" src="../assets/logo.svg" />
      <span class="title mx-1">{{ appTitle }}</span>
    </router-link>

    <v-spacer></v-spacer>

    <v-btn
      color="primary"
      dark
      depressed
      class="mx-1"
      :to="registerNav.to"
      v-if="isAuthPage && !isRegisterPage"
    >{{ registerNav.text }}</v-btn>
    <v-btn
      color="primary"
      dark
      depressed
      class="mx-1"
      :to="loginNav.to"
      v-if="isAuthPage && !isLoginPage"
    >{{ loginNav.text }}</v-btn>

    <v-menu offset-y v-if="!isAuthPage" min-width="240">
      <template v-slot:activator="{ on }">
        <v-btn class="mx-1" text v-on="on">
          <v-icon class="mr-1">mdi-account-circle-outline</v-icon>
          {{ user?user.displayName:'' }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item dense v-for="item in accountDropdownItems"
          :key="item.text" :to="item.to">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<style scoped>
a.brand {
  color: inherit;
  text-decoration: none;
}
</style>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapState([
      'isAuthPage',
      'isLoginPage',
      'isRegisterPage',
      'isForgotPasswordPage',
      'appTitle',
      'user',
      'navigation',
    ]),
    ...mapState('routes', {
      homeNav: state => state.HOME,
      loginNav: state => state.LOGIN,
      registerNav: state => state.REGISTER,
    }),
    ...mapGetters('routes', [
      'accountDropdownItems',
    ]),
  },
};
</script>
